import G from "./highrise1055.mjs";
import { defineComponent as de, h as f, Transition as ce, toRef as L, inject as fe, ref as B, watch as me, provide as ue, onMounted as ge, computed as N } from "vue";
import { formItemInjectionKey as be } from "./highrise1056.mjs";
import { formItemInstsInjectionKey as he, formInjectionKey as ve } from "./highrise1051.mjs";
import ke from "./highrise1057.mjs";
import { formItemSize as pe, formItemMisc as ye, formItemRule as Re } from "./highrise1058.mjs";
import { resolveWrappedSlot as Se } from "./highrise1059.mjs";
import { useInjectionInstanceCollection as we } from "./highrise1060.mjs";
import _e from "./highrise1053.mjs";
import { createId as J } from "./highrise1061.mjs";
import Z from "./highrise984.mjs";
import { createKey as _ } from "./highrise314.mjs";
import { useThemeClass as $e } from "./highrise1062.mjs";
import Ce from "./highrise1019.mjs";
import xe from "./highrise1063.mjs";
import { warn as Q } from "./highrise1064.mjs";
var U = function(r, e, u, t) {
  function h(s) {
    return s instanceof u ? s : new u(function(k) {
      k(s);
    });
  }
  return new (u || (u = Promise))(function(s, k) {
    function C(l) {
      try {
        b(t.next(l));
      } catch (d) {
        k(d);
      }
    }
    function v(l) {
      try {
        b(t.throw(l));
      } catch (d) {
        k(d);
      }
    }
    function b(l) {
      l.done ? s(l.value) : h(l.value).then(C, v);
    }
    b((t = t.apply(r, e || [])).next());
  });
};
const Pe = Object.assign(Object.assign({}, Z.props), {
  label: String,
  labelWidth: [Number, String],
  labelStyle: [String, Object],
  labelAlign: String,
  labelPlacement: String,
  path: String,
  first: Boolean,
  rulePath: String,
  required: Boolean,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: void 0
  },
  rule: [Object, Array],
  size: String,
  ignorePathChange: Boolean,
  validationStatus: String,
  feedback: String,
  feedbackClass: String,
  feedbackStyle: [String, Object],
  showLabel: {
    type: Boolean,
    default: void 0
  },
  labelProps: Object
});
function X(r, e) {
  return (...u) => {
    try {
      const t = r(...u);
      return !e && (typeof t == "boolean" || t instanceof Error || Array.isArray(t)) || t != null && t.then ? t : (t === void 0 || Q("form-item/validate", `You return a ${typeof t} typed value in the validator method, which is not recommended. Please use ${e ? "`Promise`" : "`boolean`, `Error` or `Promise`"} typed value instead.`), !0);
    } catch (t) {
      Q("form-item/validate", "An error is catched in the validation, so the validation won't be done. Your callback in `validate` method of `n-form` or `n-form-item` won't be called in this validation."), console.error(t);
      return;
    }
  };
}
const Ke = de({
  name: "FormItem",
  props: Pe,
  setup(r) {
    we(he, "formItems", L(r, "path"));
    const {
      mergedClsPrefixRef: e,
      inlineThemeDisabled: u
    } = _e(r), t = fe(ve, null), h = pe(r), s = ye(r), {
      validationErrored: k,
      validationWarned: C
    } = s, {
      mergedRequired: v,
      mergedRules: b
    } = Re(r), {
      mergedSize: l
    } = h, {
      mergedLabelPlacement: d,
      mergedLabelAlign: p,
      mergedRequireMarkPlacement: H
    } = s, j = B([]), K = B(J()), ee = t ? L(t.props, "disabled") : B(!1), te = Z("Form", "-form-item", ke, Ce, r, e);
    me(L(r, "path"), () => {
      r.ignorePathChange || E();
    });
    function E() {
      j.value = [], k.value = !1, C.value = !1, r.feedback && (K.value = J());
    }
    const x = (...a) => U(this, [...a], void 0, function* (m = null, y = () => !0, o = {
      suppressWarning: !0
    }) {
      const {
        path: R
      } = r;
      o ? o.first || (o.first = r.first) : o = {};
      const {
        value: $
      } = b, I = t ? xe(t.props.model, R || "") : void 0, M = {}, z = {}, S = (m ? $.filter((n) => Array.isArray(n.trigger) ? n.trigger.includes(m) : n.trigger === m) : $).filter(y).map((n, c) => {
        const i = Object.assign({}, n);
        if (i.validator && (i.validator = X(i.validator, !1)), i.asyncValidator && (i.asyncValidator = X(i.asyncValidator, !0)), i.renderMessage) {
          const F = `__renderMessage__${c}`;
          z[F] = i.message, i.message = F, M[F] = i.renderMessage;
        }
        return i;
      }), w = S.filter((n) => n.level !== "warning"), O = S.filter((n) => n.level === "warning"), g = {
        valid: !0,
        errors: void 0,
        warnings: void 0
      };
      if (!S.length) return g;
      const A = R ?? "__n_no_path__", W = new G({
        [A]: w
      }), T = new G({
        [A]: O
      }), {
        validateMessages: V
      } = (t == null ? void 0 : t.props) || {};
      V && (W.messages(V), T.messages(V));
      const q = (n) => {
        j.value = n.map((c) => {
          const i = (c == null ? void 0 : c.message) || "";
          return {
            key: i,
            render: () => i.startsWith("__renderMessage__") ? M[i]() : i
          };
        }), n.forEach((c) => {
          var i;
          !((i = c.message) === null || i === void 0) && i.startsWith("__renderMessage__") && (c.message = z[c.message]);
        });
      };
      if (w.length) {
        const n = yield new Promise((c) => {
          W.validate({
            [A]: I
          }, o, c);
        });
        n != null && n.length && (g.valid = !1, g.errors = n, q(n));
      }
      if (O.length && !g.errors) {
        const n = yield new Promise((c) => {
          T.validate({
            [A]: I
          }, o, c);
        });
        n != null && n.length && (q(n), g.warnings = n);
      }
      return !g.errors && !g.warnings ? E() : (k.value = !!g.errors, C.value = !!g.warnings), g;
    });
    function ne() {
      x("blur");
    }
    function ae() {
      x("change");
    }
    function ie() {
      x("focus");
    }
    function re() {
      x("input");
    }
    function le(a, m) {
      return U(this, void 0, void 0, function* () {
        let y, o, R, $;
        return typeof a == "string" ? (y = a, o = m) : a !== null && typeof a == "object" && (y = a.trigger, o = a.callback, R = a.shouldRuleBeApplied, $ = a.options), yield new Promise((I, M) => {
          x(y, R, $).then(({
            valid: z,
            errors: S,
            warnings: w
          }) => {
            z ? (o && o(void 0, {
              warnings: w
            }), I({
              warnings: w
            })) : (o && o(S, {
              warnings: w
            }), M(S));
          });
        });
      });
    }
    ue(be, {
      path: L(r, "path"),
      disabled: ee,
      mergedSize: h.mergedSize,
      mergedValidationStatus: s.mergedValidationStatus,
      restoreValidation: E,
      handleContentBlur: ne,
      handleContentChange: ae,
      handleContentFocus: ie,
      handleContentInput: re
    });
    const oe = {
      validate: le,
      restoreValidation: E,
      internalValidate: x
    }, D = B(null);
    ge(() => {
      if (!s.isAutoLabelWidth.value) return;
      const a = D.value;
      if (a !== null) {
        const m = a.style.whiteSpace;
        a.style.whiteSpace = "nowrap", a.style.width = "", t == null || t.deriveMaxChildLabelWidth(Number(getComputedStyle(a).width.slice(0, -2))), a.style.whiteSpace = m;
      }
    });
    const Y = N(() => {
      var a;
      const {
        value: m
      } = l, {
        value: y
      } = d, o = y === "top" ? "vertical" : "horizontal", {
        common: {
          cubicBezierEaseInOut: R
        },
        self: {
          labelTextColor: $,
          asteriskColor: I,
          lineHeight: M,
          feedbackTextColor: z,
          feedbackTextColorWarning: S,
          feedbackTextColorError: w,
          feedbackPadding: O,
          labelFontWeight: g,
          [_("labelHeight", m)]: A,
          [_("blankHeight", m)]: W,
          [_("feedbackFontSize", m)]: T,
          [_("feedbackHeight", m)]: V,
          [_("labelPadding", o)]: q,
          [_("labelTextAlign", o)]: n,
          [_(_("labelFontSize", y), m)]: c
        }
      } = te.value;
      let i = (a = p.value) !== null && a !== void 0 ? a : n;
      return y === "top" && (i = i === "right" ? "flex-end" : "flex-start"), {
        "--n-bezier": R,
        "--n-line-height": M,
        "--n-blank-height": W,
        "--n-label-font-size": c,
        "--n-label-text-align": i,
        "--n-label-height": A,
        "--n-label-padding": q,
        "--n-label-font-weight": g,
        "--n-asterisk-color": I,
        "--n-label-text-color": $,
        "--n-feedback-padding": O,
        "--n-feedback-font-size": T,
        "--n-feedback-height": V,
        "--n-feedback-text-color": z,
        "--n-feedback-text-color-warning": S,
        "--n-feedback-text-color-error": w
      };
    }), P = u ? $e("form-item", N(() => {
      var a;
      return `${l.value[0]}${d.value[0]}${((a = p.value) === null || a === void 0 ? void 0 : a[0]) || ""}`;
    }), Y, r) : void 0, se = N(() => d.value === "left" && H.value === "left" && p.value === "left");
    return Object.assign(Object.assign(Object.assign(Object.assign({
      labelElementRef: D,
      mergedClsPrefix: e,
      mergedRequired: v,
      feedbackId: K,
      renderExplains: j,
      reverseColSpace: se
    }, s), h), oe), {
      cssVars: u ? void 0 : Y,
      themeClass: P == null ? void 0 : P.themeClass,
      onRender: P == null ? void 0 : P.onRender
    });
  },
  render() {
    const {
      $slots: r,
      mergedClsPrefix: e,
      mergedShowLabel: u,
      mergedShowRequireMark: t,
      mergedRequireMarkPlacement: h,
      onRender: s
    } = this, k = t !== void 0 ? t : this.mergedRequired;
    s == null || s();
    const C = () => {
      const v = this.$slots.label ? this.$slots.label() : this.label;
      if (!v) return null;
      const b = f("span", {
        class: `${e}-form-item-label__text`
      }, v), l = k ? f("span", {
        class: `${e}-form-item-label__asterisk`
      }, h !== "left" ? " *" : "* ") : h === "right-hanging" && f("span", {
        class: `${e}-form-item-label__asterisk-placeholder`
      }, " *"), {
        labelProps: d
      } = this;
      return f("label", Object.assign({}, d, {
        class: [d == null ? void 0 : d.class, `${e}-form-item-label`, `${e}-form-item-label--${h}-mark`, this.reverseColSpace && `${e}-form-item-label--reverse-columns-space`],
        style: this.mergedLabelStyle,
        ref: "labelElementRef"
      }), h === "left" ? [l, b] : [b, l]);
    };
    return f("div", {
      class: [`${e}-form-item`, this.themeClass, `${e}-form-item--${this.mergedSize}-size`, `${e}-form-item--${this.mergedLabelPlacement}-labelled`, this.isAutoLabelWidth && `${e}-form-item--auto-label-width`, !u && `${e}-form-item--no-label`],
      style: this.cssVars
    }, u && C(), f("div", {
      class: [`${e}-form-item-blank`, this.mergedValidationStatus && `${e}-form-item-blank--${this.mergedValidationStatus}`]
    }, r), this.mergedShowFeedback ? f("div", {
      key: this.feedbackId,
      style: this.feedbackStyle,
      class: [`${e}-form-item-feedback-wrapper`, this.feedbackClass]
    }, f(ce, {
      name: "fade-down-transition",
      mode: "out-in"
    }, {
      default: () => {
        const {
          mergedValidationStatus: v
        } = this;
        return Se(r.feedback, (b) => {
          var l;
          const {
            feedback: d
          } = this, p = b || d ? f("div", {
            key: "__feedback__",
            class: `${e}-form-item-feedback__line`
          }, b || d) : this.renderExplains.length ? (l = this.renderExplains) === null || l === void 0 ? void 0 : l.map(({
            key: H,
            render: j
          }) => f("div", {
            key: H,
            class: `${e}-form-item-feedback__line`
          }, j())) : null;
          return p ? v === "warning" ? f("div", {
            key: "controlled-warning",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--warning`
          }, p) : v === "error" ? f("div", {
            key: "controlled-error",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--error`
          }, p) : v === "success" ? f("div", {
            key: "controlled-success",
            class: `${e}-form-item-feedback ${e}-form-item-feedback--success`
          }, p) : f("div", {
            key: "controlled-default",
            class: `${e}-form-item-feedback`
          }, p) : null;
        });
      }
    })) : null);
  }
});
export {
  Ke as default,
  Pe as formItemProps
};
